import { useState } from 'react';
import { autoUpdate, offset, useFloating } from '@floating-ui/react-dom';
import PropTypes from 'prop-types';

import { FLOATING_PLACEMENT } from 'src/data/ui';

import { useStyles } from './useStyles';

const DEFAULT_SIZE = 30;

const propTypes = {
  classes: PropTypes.shape(),
  targetElement: PropTypes.instanceOf(Element),
  size: PropTypes.number,
  color: PropTypes.string,
  placement: PropTypes.oneOf(Object.values(FLOATING_PLACEMENT)),
};

const defaultProps = {
  classes: null,
  targetElement: null,
  size: DEFAULT_SIZE,
  color: null,
  placement: FLOATING_PLACEMENT.right,
};

export const Beacon = ({ classes, targetElement, size, color, placement }) => {
  const styles = useStyles({ classes, size, color });
  const [beaconElement, setBeaconElement] = useState(null);

  const { floatingStyles } = useFloating({
    elements: {
      floating: beaconElement,
      reference: targetElement,
    },
    placement,
    strategy: 'absolute',
    middleware: [
      offset(({ rects }) => ({
        mainAxis: -rects.floating.width,
      })),
    ],
    whileElementsMounted: autoUpdate,
  });

  if (!targetElement) {
    return null;
  }

  return (
    <div
      className={styles.root}
      ref={setBeaconElement}
      style={floatingStyles}
    >
      <div className={styles.pulse} />
      <div className={styles.dot} />
    </div>
  );
};

Beacon.propTypes = propTypes;
Beacon.defaultProps = defaultProps;
